var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58564 0.79991L0.22168 7.16387L1.63589 8.57808L1.63604 8.57794L6.58594 13.5278L8.00015 12.1136L3.05026 7.16372L7.99985 2.21412L6.58564 0.79991Z",
    fill: "#A4AAB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightScroll);
export default __webpack_public_path__ + "static/media/right-scroll.c806d432dfd4d8d7c4301e009904149c.svg";
export { ForwardRef as ReactComponent };